import { create } from "zustand";
import { ApiError, api, type User } from "./api";

type AuthState = {
  user: User | null;
  loading: boolean;
  bootstrap: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
};

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: true,

  bootstrap: async () => {
    try {
      const me = await api.get<User>("/api/auth/me");
      set({ user: me, loading: false });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        set({ user: null, loading: false });
        return;
      }
      set({ loading: false });
      throw err;
    }
  },

  login: async (email, password) => {
    const { user } = await api.post<{ user: User }>("/api/auth/login", {
      email,
      password,
    });
    set({ user });
  },

  logout: async () => {
    await api.post("/api/auth/logout");
    set({ user: null });
  },
}));

export function canEdit(user: User | null): boolean {
  return user?.rol === "admin" || user?.rol === "soporte";
}

export function isAdmin(user: User | null): boolean {
  return user?.rol === "admin";
}
